import {Directive, ElementRef, HostListener} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
  selector: '[appTrimOnBlur]'
})
export class TrimOnBlurDirective {
  constructor(private el: ElementRef, private control: NgControl) {
  }


  @HostListener('blur') onBlur() {
    if (this.control && this.control.control) {
      const currentValue = this.control.value;
      if (typeof currentValue === 'string') {
        const trimmedValue = currentValue.trim();
        if (currentValue !== trimmedValue) {
          this.control.control.setValue(trimmedValue, {emitEvent: false});
          // Forzar actualización de validación
          this.control.control.updateValueAndValidity();
        }
      }
    }
  }
}

